import { scrollToElement } from "./scroll-to-element";

export default function ScrollToRichText() {
  const wrapper = document.querySelectorAll<HTMLDivElement>(".rich-text");

  if (wrapper) {
    wrapper.forEach((item) => {
      const scrollToBtns = item.querySelectorAll<HTMLAnchorElement>(".js-scroll-to-btn");

      const handleScrollTo = (id: string) => {
        if (id) {
          scrollToElement(id, { smooth: true });
        }
      };

      if (scrollToBtns && scrollToBtns.length > 0) {
        scrollToBtns.forEach((btn) => {
          const scrollId = btn.hash ? btn.hash.substring(1) : null;

          if (scrollId) {
            btn.addEventListener("click", (e) => {
              e.preventDefault();
              handleScrollTo(scrollId);
            });
          }
        });
      }
    });
  }
}
